// Temporary UI feature toggles (NOT entitlement gates — see lib/features.js).
//
// These hide UI surfaces regardless of a user's entitlements. Flip back to
// `true` to re-expose. Backend functionality is left intact, so toggling is
// purely a front-end show/hide.

// Reseller console (/reseller + the dashboard nav link). Hidden for now.
export const RESELLER_CONSOLE_ENABLED = false;
